import React from 'react';
import Editor, { defaultCommands } from '@uiw/react-markdown-editor';
import { EditorView } from "@codemirror/view";
import GridOn from '@material-ui/icons/GridOn';
import keys from 'lodash/keys';
import map from 'lodash/map';
import { makeStyles } from '@material-ui/core';
import { func, object, string } from 'prop-types';

export const MarkdownEditor = ({
    value,
    onChange,
    ...rest
}) => {
    const handleChange = (text) => {
        onChange(text);
    };
    const classes = useStyles(rest);
    const tableCmd = {
        name: "table",
        keyCommand: "table",
        buttonProps: { "aria-label": "Insert table" },
        icon: (
            <GridOn
                style={{
                    height: 14,
                    width: 14,
                }}
            />
        ),
        execute: ({ state, view }) => {
            if (!state || !view) return;
            const lineInfo = view.state.doc.lineAt(view.state.selection.main.from);
            const mark = `| Head | Head |\n| ---  | ---  |\n| Data | Data |\n| Data | Data |`;
            view.dispatch({
              changes: {
                from: lineInfo.from,
                to: lineInfo.to,
                insert: `${mark}`,
              },
              // selection: EditorSelection.range(lineInfo.from + mark.length, lineInfo.to),
              selection: { anchor: lineInfo.from + mark.length },
            });
        },
    };
    const toolsKeys = keys(defaultCommands).filter(key => key !== 'fullscreen' && key !== 'preview');
    const existingTools = map(toolsKeys, key => defaultCommands[key]);

    return (
        <div className={classes.editorContainer}>
            <Editor
                className={classes.editorInput}
                enableScroll
                extensions={[EditorView.lineWrapping]}
                height="370px"
                onChange={handleChange}
                toolbars={[...existingTools, tableCmd]}
                value={(value)}
                visible
            />
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        editorContainer: {
            marginBottom: '10px',
            '& .md-editor-toolbar': {
                justifyContent: 'left',
            },
        },
        editorInput: {
            marginTop: '10px',
            minHeight: '400px',
            width: '100%',
        },
        icon: {
            fontSize: '14px',
        },
    }),
);

MarkdownEditor.propTypes = {
    options: object,
    name: string,
    value: string,
    onChange: func,
    className: object,
};